<div class="dropdown">
    <button class="btn btn-ms-secondary dropdown-toggle d-flex align-items-center gap-2 w-100" type="button"
        id="countryDropdown" data-bs-toggle="dropdown" aria-expanded="false"
    [class.is-valid]="isValid" [class.is-invalid]="hasErrors">
        @if (selectedCountry()) {
            <img [src]="`/ms/images/flags/${selectedCountry()?.alpha3Code?.toLocaleLowerCase()}.svg`" alt="{{selectedCountry()?.name}}" class="flag-icon" />
            <span class="fw-medium text-start w-100">{{selectedCountry()?.name}}</span>
        } @else {
            <span class="fw-medium text-start w-100">Select a country</span>
        }
    </button>
    <ul class="dropdown-menu w-100" aria-labelledby="countryCodeDropdown" style="overflow-y: auto;">
        <li>
            <a class="dropdown-item d-flex align-items-center gap-3 py-2" (click)="selectCountry(undefined)"
                role="button">
                <span class="flex-grow-1">Select a country</span>
            </a>
        </li>
        @for (country of countriesList(); let i= $index; track country.countryId) {
        <li>
            <a class="dropdown-item d-flex align-items-center gap-3 py-2" (click)="selectCountry(country)"
                role="button">
                <img [src]="`/ms/images/flags/${country.alpha3Code.toLowerCase()}.svg`" alt="{{country.name}}" class="flag-icon" />
                <span class="flex-grow-1">{{country.name}}</span>
            </a>
        </li>
        }
    </ul>
</div>

@if(hasErrors && touched) {
    <div class="error-messages">
        @for(error of getErrors(); track $index) {
        <p class="text-danger text-start pt-1 mb-0">{{ error }}</p>
        }
    </div>
}